import Page from 'src/apipages/reference/response/[schema]/index';

export default Page;
